import React from 'react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Baldev',
      position: 'CEO, Polymer Industries Ltd.',
      text: '"BSB Fortrade has transformed our polymer sourcing process. Their reliability and competitive pricing have made them our go-to partner for all polymer needs."',
      avatar: '/assets/images/client/baldev.png'
    },
   
    {
      name: 'Jay Shah',
      position: 'Director, Trading Solutions Pvt Ltd',
      text: '"The NBFC services provided by BSB have been a game-changer for our business. Quick approvals, flexible terms, and excellent customer service."',
      avatar: '/assets/images/client/jay.png'
    },
    {
      name: 'Kunal',
      position: 'Owner, Reddy Polymers',
      text: '"As a supplier, partnering with BSB has opened up new market opportunities. Their platform is user-friendly and their support team is always responsive."',
      avatar: '/assets/images/client/kunal.png'
    },
    {
      name: 'Deep khodivala',
      position: 'Supply Chain Manager, Plastix Corp',
      text: '"Excellent logistics support! BSB\'s freight services are fast, secure, and cost-effective. They\'ve helped us streamline our supply chain operations significantly."',
      avatar: '/assets/images/client/deep.png'
    },
    {
      name: 'Ujjwal Jain',
      position: 'Procurement Head, Mega Plastics',
      text: '"BSB\'s global sourcing capabilities have given us access to quality materials at competitive prices. Their team understands our needs and delivers consistently."',
      avatar: '/assets/images/client/ujjwal.png'
    },
    {
      name: 'Shivam Rabari',
      position: 'Managing Director, Singh Enterprises',
      text: '"Professional, reliable, and trustworthy. BSB Fortrade has been instrumental in helping us expand our business. Highly recommended!"',
      avatar: '/assets/images/client/shivam_rabari.png'
    }
  ];

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="container">
        <div className="section-header">
          <h2>What Our Clients Say</h2>
          <p>Hear from businesses that trust BSB Fortrade</p>
        </div>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-rating">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
              </div>
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="testimonial-author">
                <div className="author-avatar">
                  <img 
                    src={testimonial.avatar} 
                    alt={testimonial.name}
                    onError={(e) => {
                      e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(testimonial.name)}&size=150&background=064E8D&color=fff&bold=true&font-size=0.5`;
                    }}
                  />
                </div>
                <div className="author-info">
                  <h4 className="author-name">{testimonial.name}</h4>
                  <p className="author-position">{testimonial.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;

